import dayjs from "dayjs";

// Direct port of TexasAlarms_APP_FLUTTER's
// lib/features/collections/presentation/supervisor/collection_summary_aggregator.dart
// - same grouping keys, same cheque-post-dated rule, same sort order.
// Codes match payment_method.dart/service_type.dart exactly.

export const PAYMENT_METHOD_LABELS = {
  0: "Cash Deposit",
  1: "Bank",
  2: "Transfer",
  3: "M-Pesa",
  4: "Cheque",
  5: "Visit",
};

export const SERVICE_TYPE_LABELS = {
  0: "Services",
  1: "Installation",
  2: "Rent",
  3: "Alarms",
  4: "Other",
};

// `false` covers both "dated today/earlier" and "no cheque date at all" -
// there is no separate "Pre-Dated" bucket.
export const chequeIsPostDated = (row) => {
  if (!row.chqDate) return false;
  const chqDate = dayjs(row.chqDate);
  if (!chqDate.isValid()) return false;
  const reference = row.colectDate && dayjs(row.colectDate).isValid() ? dayjs(row.colectDate) : dayjs();
  return chqDate.startOf("day").isAfter(reference.startOf("day"));
};

export const summarizePostDatedCheques = (rows) => {
  const postDated = (rows || []).filter((r) => r.paymentMethod === 4 && chequeIsPostDated(r));
  return {
    count: postDated.length,
    amount: postDated.reduce((sum, r) => sum + (Number(r.amount) || 0), 0),
  };
};

const summarizeBy = (rows, keyOf, labelOf, sortComparator) => {
  const map = new Map();
  (rows || []).forEach((r) => {
    const key = keyOf(r);
    const existing = map.get(key);
    if (existing) {
      existing.count += 1;
      existing.amount += Number(r.amount) || 0;
    } else {
      map.set(key, { code: key, label: labelOf(r), count: 1, amount: Number(r.amount) || 0 });
    }
  });
  return [...map.values()].sort(sortComparator);
};

export const summarizeByEmployee = (rows) =>
  summarizeBy(
    rows,
    (r) => r.empCode ?? "—",
    (r) => r.empName || r.empCode || "—",
    (a, b) => a.label.localeCompare(b.label)
  );

export const summarizeByServiceType = (rows) =>
  summarizeBy(
    rows,
    (r) => SERVICE_TYPE_LABELS[r.serviceType] || "Unspecified",
    (r) => SERVICE_TYPE_LABELS[r.serviceType] || "Unspecified",
    (a, b) => a.label.localeCompare(b.label)
  );

const PAYMENT_TYPE_ORDER = [
  "Cash Deposit",
  "Bank",
  "Transfer",
  "M-Pesa",
  "Cheque — Current Date",
  "Cheque — Post-Dated",
  "Visit",
  "Unspecified",
];

export const summarizeByPaymentType = (rows) => {
  const labelOf = (r) => {
    if (r.paymentMethod === 4) return chequeIsPostDated(r) ? "Cheque — Post-Dated" : "Cheque — Current Date";
    return PAYMENT_METHOD_LABELS[r.paymentMethod] || "Unspecified";
  };
  return summarizeBy(
    rows,
    labelOf,
    labelOf,
    (a, b) => PAYMENT_TYPE_ORDER.indexOf(a.label) - PAYMENT_TYPE_ORDER.indexOf(b.label)
  );
};
